import Handlebars from 'handlebars';
      const _template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-test-label-human-support-direct-engaged class=\"ml-4\">\n  <span class=\"font-normal\">Served by a teammate from the beginning</span>\n</div>\n";
},"useData":true});
      export default _template;